module.exports = __webpack_public_path__ + "static/media/home-image@1x.a7318ed2.png";